import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import { Button, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DocManagementService from 'src/components/eTMF/documentUpload/service/DocManagementService';
import { useGetCountriesQuery, useGetSitesQuery } from 'src/components/Services/Utils';
import { AppState, useAppDispatch } from 'src/store';
import { setSearchDetail } from 'src/store/searchHierarchyDetails';
import { setUserDataAvailable } from 'src/store/User';
import './DashboardNavbar.scss';

export interface IMenu {
  item: { key: number; label: string; value: string; options: any };
  handleMenuItemClick: (event: any, index: number) => void;
  searchFilter: {
    Sponsor: string;
    Study: string;
    Country: string;
    Site: string;
  };
  setSearchFilter: any;
  studyList: string;
  setCountryList: any;
  setSiteList: any;
  countrylist: string;
  searchDetails: (a: string, b: string, c: string) => void;
  sitelist: string;
  currentStudy: string;
  setCurrentStudy: any;
  currentCountry: string;
  setCurrentCountry: any;
  setSiteDataList: any;
  isVersionCheck: boolean;
  studyData: any;
}

const Menu: React.FC<IMenu> = ({
  item,
  handleMenuItemClick,
  searchFilter,
  studyList,
  setCountryList,
  setSiteList,
  setSearchFilter,
  countrylist,
  sitelist,
  searchDetails,
  currentStudy,
  setCurrentStudy,
  currentCountry,
  setCurrentCountry,
  setSiteDataList,
  isVersionCheck,
  studyData
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>();
  const docService = new DocManagementService();
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);

  const [selected, setSelected] = useState<string>('');

  const [open, setOpen] = React.useState(false);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(prevOpen => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClear = (item: any, event: React.MouseEvent<HTMLElement>) => {
    let Study = SearchHierarchyDetail?.data[0].Study;
    let Country = SearchHierarchyDetail?.data[0].Country;
    let Site = SearchHierarchyDetail?.data[0].Site;
    if (studyList.indexOf(item.value) > -1) {
      setSearchDetail(dispatch, [{ ...searchFilter, Sponsor: '', Study: '--', Country: '--', Site: '--' }]);
      setSearchFilter({ ...searchFilter, Sponsor: '', Study: '--', Country: '--', Site: '--' });
      Study = '--';
      Country = '--';
      Site = '--';
    } else if (countrylist.indexOf(item.value) > -1) {
      setSearchDetail(dispatch, [{ ...searchFilter, Country: '--', Site: '--' }]);
      setSearchFilter({ ...searchFilter, Country: '--', Site: '--' });
      Country = '--';
      Site = '--';
    } else if (sitelist.indexOf(item.value) > -1) {
      setSearchDetail(dispatch, [{ ...searchFilter, Site: '--' }]);
      setSearchFilter({ ...searchFilter, Site: '--' });
      Site = '--';
    } else {
      setSearchDetail(dispatch, [{ ...searchFilter, Sponsor: '--', Study: '--', Country: '--', Site: '--' }]);
      setSearchFilter({ ...searchFilter, Sponsor: '--', Study: '--', Country: '--', Site: '--' });
      Study = '--';
      Country = '--';
      Site = '--';
    }
    searchDetails(Study, Country, Site);
    event.stopPropagation();
  };

  const handleClose = (event: any) => {
    setOpen(false);
  };
  const dispatch = useAppDispatch();
  // const handleStudyChange = async (item: string) => {
  //   const result: any = await docService.getStudyList(item);
  //   if (result.data.length != 0) {
  //     let tempC = [];
  //     let tempS = [];
  //     result.data.country.length < 1 ? (tempC = [...result.data.country]) : (tempC = [result.data.country]);
  //     result.data.site_id.length < 1 ? (tempS = [...result.data.site_id]) : (tempS = [result.data.site_id]);
  //     // tempC.push('Clear country');
  //     // tempS.push('Clear site');
  //     setCountryList(tempC);
  //     setSiteList(tempS);
  //   }
  // };

  const {
    isLoading,
    data: countryData,
    isError,
    isSuccess,
    refetch: getCountries
  } = useGetCountriesQuery(currentStudy);

  const handleStudyChange = async (item: string) => {
    setCurrentStudy(item);
  };

  // useEffect(() => {
  //   if (isError && currentStudy != '') {
  //     dispatch(setSitePermissionData(false));
  //   }
  // }, [isError, currentStudy]);

  useEffect(() => {
    getCountries();
  }, [currentStudy]);

  useEffect(() => {
    const tempC: any = [];
    if (countryData && countryData.length != 0) {
      countryData.map((country: any) => {
        tempC.push(country.name);
      });
      // setSearchFilter({ ...searchFilter, Country: tempC[0] });
      // setCurrentCountry(tempC[0]);
      dispatch(setUserDataAvailable(true));
    } else {
      dispatch(setUserDataAvailable(false));
    }
    setCountryList([... new Set(tempC)]);
    const countryCheck =
      SearchHierarchyDetail?.data[0]?.Country == undefined || SearchHierarchyDetail?.data[0]?.Country == ''
        ? tempC[0]
        : SearchHierarchyDetail?.data[0]?.Country;
    setSearchDetail(dispatch, [{ ...searchFilter, Country: countryCheck }]);
    setSearchFilter({ ...searchFilter, Country: countryCheck });
    setCurrentCountry(countryCheck);
    //close('', '');
  }, [countryData]);

  const {
    isLoading: getSiteLoading,
    data: sitesData,
    isError: getSiteError,
    isSuccess: getSiteSuccess,
    refetch: getSites
  } = useGetSitesQuery({ currentStudy, currentCountry });

  const handleCountryChange = async (item: string) => {
    setCurrentCountry(item);
  };

  // useEffect(() => {
  //   if (getSiteError && currentCountry != '') {
  //     dispatch(setSitePermissionData(false));
  //   }
  // }, [getSiteError, currentCountry]);

  useEffect(() => {
    getSites();
  }, [currentCountry]);

  useEffect(() => {
    const tempS: string[] = [];
    if (sitesData && sitesData.length != 0) {
      sitesData.map((site: any) => {
        tempS.push(site.name);
      });
      dispatch(setUserDataAvailable(true));
    } else {
      dispatch(setUserDataAvailable(false));
    }
    setSiteList([... new Set(tempS)]);
    const siteCheck =
      SearchHierarchyDetail?.data[0]?.Site == undefined || SearchHierarchyDetail?.data[0]?.Site == ''
        ? tempS[0]
        : SearchHierarchyDetail?.data[0]?.Site;
    setSearchDetail(dispatch, [{ ...searchFilter, Country: currentCountry, Site: siteCheck }]);
    setSearchFilter({ ...searchFilter, Country: currentCountry, Site: siteCheck });

    //   if (tempS.length > 0) {
    //     tempS = tempS.sort();
    //     const site = tempS[0];
    //     const findSiteRole: any = sitesData.find((item: any) => item.name == site);
    //     let foundSite = null;
    //     if (siteClicksData) {
    //       foundSite = siteClicksData.find((item: any) => item.site_id == site);
    //     }
    //     if (userClicksData && foundSite && foundSite.count == userClicksData.click_count) {
    //       close(userClicksData.site_id, findSiteRole.role);
    //       userSiteClicksUpdate(userClicksData.site_id);
    //       setSearchFilter({ ...searchFilter, Country: currentCountry, Site: userClicksData.site_id });
    //     } else {
    //       close(site, findSiteRole.role);
    //       userSiteClicksUpdate(site);
    //       setSearchFilter({ ...searchFilter, Country: currentCountry, Site: site });
    //     }
    //   }
    // }
    // setSiteDetails(sitesData);
    if (setSiteDataList) {
      setSiteDataList(sitesData);
    }
  }, [sitesData]);

  //console.log('sitesData', sitesData);

  const handleChange = (item: any, index: number) => {
    let Study = '--';
    let Country = '--';
    let Site = '--';
    if (studyList.indexOf(item) > -1) {
      let sponsorVal = 'Pihealth';
      const currentStudyObj: any = studyData?.filter((studyInfo: any) => studyInfo.name === item);
      if (currentStudyObj) sponsorVal = currentStudyObj[0]?.sponsor_name;

      setSearchDetail(dispatch, [{ ...searchFilter, Sponsor: sponsorVal, Study: item, Country: '--', Site: '--' }]);
      setSearchFilter({ ...searchFilter, Sponsor: sponsorVal, Study: item, Country: '--', Site: '--' });
      Study = item;
      handleStudyChange(item);
    } else if (countrylist.indexOf(item) > -1) {
      setSearchDetail(dispatch, [{ ...searchFilter, Country: item }]);
      setSearchFilter({ ...searchFilter, Country: item });
      Study = searchFilter.Study;
      Country = item;
      handleCountryChange(item);
    } else if (sitelist.indexOf(item) > -1) {
      setSearchDetail(dispatch, [{ ...searchFilter, Site: item }]);
      setSearchFilter({ ...searchFilter, Site: item });
      Study = searchFilter.Study;
      Country = searchFilter.Country;
      Site = item;
    } else {
      setSearchDetail(dispatch, [{ ...searchFilter, Sponsor: item, Study: '--', Country: '--', Site: '--' }]);
      setSearchFilter({ ...searchFilter, Sponsor: item, Study: '--', Country: '--', Site: '--' });
      Study = '--';
      Country = '--';
      Site = '--';
    }
    searchDetails(Study, Country, Site);
  };

  return (
    <React.Fragment key={item.key}>
      <Button
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        aria-haspopup="menu"
        onClick={e => {
          handleToggle(e);
        }}
      >
        {item.label}: &nbsp; <span>{item.value === '--' ? '' : item.value}</span>
        <IconButton
          aria-label="delete"
          size="small"
          className={
            item.value === '--' || item.value === '' || item.value === undefined || isVersionCheck
              ? 'hide'
              : 'close-small-btn'
          }
          onClick={e => handleClear(item, e)}
        >
          {' '}
          {/* className="close-small-btn" */}
          <CloseIcon />
        </IconButton>
        {/* <ButtonGroup variant="contained" aria-label="split button">
        <Button>
          {item.label}: {item.value === '--' ? '' : item.value}
        </Button>
        <Button className={item.value === '--' || item.value === '' ? 'hide' : ''} onClick={e => handleClear(item)}>
          <CloseIcon />
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={e => {
            handleToggle(e);
          }}
        > 
          <ArrowDropDownIcon />*/}
        <Popper
          open={open}
          anchorEl={anchorEl}
          role={undefined}
          transition
          disablePortal
          placement="bottom-start"
          onResize={undefined}
          onResizeCapture={undefined}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              /*  style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }} */
            >
              <Paper elevation={4}>
                <ClickAwayListener onClickAway={e => handleClose(e)}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {item.key === 4
                      ? searchFilter.Country != '--'
                        ? item.options.map((item: any, index: number) => (
                            <MenuItem
                              key={index}
                              value={item}
                              onClick={e => handleChange(item, index)}
                              disabled={isVersionCheck}
                            >
                              {item}
                            </MenuItem>
                          ))
                        : ''
                      : item.key === 2
                      ? item.options.map((item: any, index: number) => (
                          <MenuItem
                            key={index}
                            value={item}
                            onClick={e => handleChange(item, index)}
                            disabled={isVersionCheck}
                          >
                            {item}
                          </MenuItem>
                        ))
                      : item.key === 3
                      ? searchFilter.Study != '--'
                        ? item.options.map((item: any, index: number) => (
                            <MenuItem
                              key={index}
                              value={SearchHierarchyDetail.data[0].Country}
                              onClick={e => handleChange(item, index)}
                              disabled={isVersionCheck}
                            >
                              {item}
                            </MenuItem>
                          ))
                        : ''
                      : item.options.map((item: any, index: number) => (
                          <MenuItem
                            key={index}
                            value={item}
                            onClick={e => handleChange(item, index)}
                            disabled={isVersionCheck}
                          >
                            {item}
                          </MenuItem>
                        ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Button>
      {/* </ButtonGroup> */}
    </React.Fragment>
  );
};

export default memo(Menu);
